import { db } from "../../../config/firebaseconfig"
import { uniqBy } from 'lodash'
import forOwn from 'mout/object/forOwn'

export default function isLicensedUser(users, setLoader) {
    setLoader({ loadingLicenses: true })
    let uniqLicenses = []
    users.forEach(user => { (user.licenses) && forOwn(user.licenses, (val, key) => val && uniqLicenses.push(key)) })

    let licensesArr = []
    let licensePromise = []
    uniqBy(uniqLicenses).forEach(license => {
        let dataLicenses = db.collection('accountLicenses').where('id', '==', license).get()
        licensePromise.push(dataLicenses);
    })

    return Promise.all(licensePromise).then(result => {
        result.forEach(querySnapshot => {
            querySnapshot.forEach(doc => {
                if (doc.exists) {
                    const data = doc.data()
                    if (!data.deleted) {
                        licensesArr.push(data.licensedUsers)
                        setLoader({ licenseEndDate: data.endDate })
                    }
                }
            })
        })


    }).then(() => {
        let licensedUsers = []
        licensesArr.forEach(user => forOwn(user, (val, key) => val && licensedUsers.push(key)))
        return setLoader({ loadingLicenses: false, licensedUsers: uniqBy(licensedUsers) })
    })
        .catch(err => console.log(err))
}



// WEBPACK FOOTER //
// ./src/helpers/users/licenses/isLicensedUser.js